import { FormControl, FormGroup, Validators } from '@angular/forms';

export const createAddressForm = () =>
  new FormGroup({
    department: new FormControl(null, [Validators.required]),
    province: new FormControl(null, [Validators.required]),
    district: new FormControl(null, [Validators.required]),
    streetType: new FormControl(null, [Validators.required]),
    streetName: new FormControl(null, [Validators.required]),
    streetNumber: new FormControl(null, [Validators.required]),
    block: new FormControl('', [Validators.required]),
    lot: new FormControl('', [Validators.required]),
    apartment: new FormControl(null),
    //Added only to requiremnt: Send the names instead of code.
    departmentName: new FormControl(null),
    provinceName: new FormControl(null),
    districtName: new FormControl(null),
  });

export const dynamicAddressValidator = ({ on: form }: { on: FormGroup }) => {
  const { streetNumber: streetNumberControl, block: blockControl, lot: lotControl } = form.controls;
  const streetNumberHasValue = !!streetNumberControl.value;
  const blockHasValue = !!blockControl.value;
  const lotHasValue = !!lotControl.value;

  if (!streetNumberHasValue) {
    blockControl.addValidators(Validators.required);
    lotControl.addValidators(Validators.required);
  } else {
    blockControl.removeValidators(Validators.required);
    lotControl.removeValidators(Validators.required);

    if (blockHasValue || lotHasValue) {
      blockControl.addValidators(Validators.required);
      lotControl.addValidators(Validators.required);
    }
  }

  streetNumberControl.updateValueAndValidity({ emitEvent: false });
  blockControl.updateValueAndValidity({ emitEvent: false });
  lotControl.updateValueAndValidity({ emitEvent: false });
};
